import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.report.util`, {
  'common.learn-more': `Learn more`,
  'query-builder.data-type.boolean': `True / False`,
  'query-builder.data-type.custom-type': `Custom {{type}}`,
  'query-builder.data-type.date': `Date`,
  'query-builder.data-type.list': `List`,
  'query-builder.data-type.number': `Number`,
  'query-builder.data-type.object': `Object`,
  'query-builder.data-type.string': `String`,
  'query-builder.number-of-users-who-did-label': `Number of Users who did {{event}}...`,
  'reports.actions.errors.error-loading-report': `Error loading report`,
  'reports.actions.errors.report-not-found': `Report does not exist`,
  'reports.actions.exports.enable-cta': `Contact your project administrator to enable`,
  'reports.actions.exports.export': `Export`,
  'reports.actions.exports.export-csv': `Export CSV`,
  'reports.actions.exports.export-csvclipboard': `Copy CSV`,
  'reports.actions.exports.export-pdf': `Export PDF`,
  'reports.actions.exports.export-png': `Export PNG`,
  'reports.actions.exports.upgrade-cta': `Upgrade your plan to export reports as {{format}}. [$t(common.learn-more)](https://mixpanel.com/pricing)`,
  'reports.date-range.disabled.date-beyond-data-retention': `Data is only available from {{date}} onwards.`,
  'reports.date-range.warn-only.auto-corrected-for-data-retention': `$t(reports.date-range.disabled.date-beyond-data-retention) The selected date range has been adjusted in accordance with your data lookback period.`,
  'reports.lift-comparison.previous-period.custom': `Custom`,
});
